/* global axios */
import ApiClient from './ApiClient';

class BulkActionsAPI extends ApiClient {
  constructor() {
    super('bulk_actions', { accountScoped: true });
  }

  checkContacts(contactIds) {
    return axios.post(`${this.url}/check_contacts`, { ids: contactIds });
  }
}

export default new BulkActionsAPI();
